<template>
  <div class="login-page">
    <Header></Header>
    <div v-if="validatePage._id != null" class="login-ctn">
      <div class="login-box">
        <div class="login-title">
          <h1>Cambiar contraseña</h1>
        </div>
        <div class="login-form">
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-text-field
              autofocus
              type="password"
              :name="Math.random()"
              color="#ff9f1c"
              :rules="rulesPass"
              label="Nueva contraseña"
              autocomplete="new-password"
              outlined
              v-model="password"
            ></v-text-field>
            <v-text-field
              type="password"
              :name="Math.random()"
              color="#ff9f1c"
              :rules="rulesVerify"
              label="Repetir contraseña"
              autocomplete="new-password"
              outlined
              v-model="password_verify"
            ></v-text-field>
            <div class="login-btn">
              <v-btn @click="validate" class="btn-send" :disabled="disabled"
                >Cambiar contraseña</v-btn
              >
              <p class="line"></p>
            </div>
          </v-form>
        </div>

        <v-alert
          class="alert-md"
          v-bind:style="{
            background: `${styleColor.bg} !important`
          }"
          text
          v-if="msj"
        >
          <span v-bind:style="{ color: styleColor.text }">{{ msj }}</span>
          <p>
            <router-link v-if="styleColor.text != '#fc3d21'" to="/">
              <span>Regresar al iniciar sesión</span>
            </router-link>

            <a v-else @click="clearForm" href="#">Intentarlo de nuevo</a>
          </p>
        </v-alert>
      </div>
    </div>
    <div v-else class="login-ctn">
      <div class="login-box">
        <div class="login-title">
          <h1>Su solicitud a expirado</h1>
          <p>su link de recuperación no es válido o ha expirado.</p>
        </div>
        <div class="login-btn">
          <v-btn to="/forgot" class="btn-send"
            >Nueva solicitud de contraseña</v-btn
          >
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import { mapActions } from "vuex";

//import axios from "axios";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "Recovery",
  components: {
    Header,
    Footer
  },
  data() {
    return {
      valid: false,
      truePage: null,
      email: "",
      rulesPass: [
        //(v) => (!v || ) || 'El correo electrónico excede los 50 caracteres permitido.',
        (v) =>
          (v && v.length >= 10 && v.length <= 20) ||
          "La contraseña debe contener 10 caracteres."
      ],
      rulesVerify: [
        (v) =>
          (v && v.length >= 10 && v.length <= 20) ||
          "La contraseña debe contener 10 caracteres.",
        (v) => v == this.password || "Las contraseñas deben coincidir."
      ],
      password: null,
      password_verify: null,
      //rulesPass: [(v) => !!v || 'La contraseña es requerida.'],
      msj: null,
      disabled: null,
      styleColor: {
        bg: null,
        text: null
      }
    };
  },
  async mounted() {
    this.truePage = await this.tokenValidate(this.$route.params.code);
  },
  methods: {
    ...mapActions(["recoveryPassword", "tokenValidate"]),
    async validate() {
      if (this.$refs.form.validate()) {
        this.disabled = "disabled";
        //console.log(this.email);
        let resolve = await this.recoveryPassword({
          password: this.password,
          token: this.$route.params.code
        });
        //console.log(resolve);

        if (resolve == 200) {
          //console.log(resolve);
          this.msj =
            "La contraseña se ha cambiado correctamente, de clic en regresar para que pueda iniciar sesión";
          this.styleColor = { bg: "rgb(0 128 0 / 20%)", text: "#008000" };
        } else {
          if (resolve.code == "email") {
            this.msj = "El correo electrónico no existe.";
            this.styleColor = { bg: "rgb(252 61 33 / 20%)", text: "#fc3d21" };
          }
          if (resolve.code == "server") {
            this.msj = "Error de conexión con el servidor.";
            this.styleColor = { bg: "rgb(252 61 33 / 20%)", text: "#fc3d21" };
          }
          //console.log("despues", resolve);
          //console.log("error servidor");
        }
      } else {
        this.disabled = "disabled";
        this.msj = "EL campo del correo electrónico no puede ser vació.";
        this.styleColor = { bg: "rgb(252 61 33 / 20%)", text: "#fc3d21" };
      }
    },
    async clearForm() {
      this.disabled = null;
      this.email = "";
      this.msj = null;
      this.styleColor = {
        bg: null,
        text: null
      };
    }
  },
  computed: {
    validatePage() {
      if (this.truePage != null) {
        return this.truePage;
      } else {
        return false;
      }
    }
  }
};
</script>

<style lang="scss">
@import "../../assets/scss/base.scss";
</style>
